import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  addDudaConfiguration,
  type AddDudaConfigurationPayload,
} from 'api/admin/businesses/dudaConfiguration';

export const useAddDudaConfiguration = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, AddDudaConfigurationPayload>({
    mutationFn: async ({ businessId, data }) => {
      return addDudaConfiguration({ businessId, data });
    },
    onSuccess: async () => {
      toaster('Duda configuration has been added', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while adding Duda configuration', {
        icon: '❌',
      });
      return error;
    },
  });
};
